import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import {
  CollaboratorInvitation,
  CollaboratorRoleEnum,
} from "@models/collaborator";
import { PaginatorState } from "primeng/paginator";
import {
  catchError,
  combineLatest,
  finalize,
  of,
  startWith,
  Subject,
  switchMap,
  tap,
} from "rxjs";
import { CollaboratorsService } from "../../../services/collaborators.service";
import { CollaboratorInvitationsListComponent } from "./collaborator-invitations-list/collaborator-invitations-list.component";

@Component({
  selector: "app-collaborator-invitations-tab",
  imports: [CollaboratorInvitationsListComponent, CommonModule],
  templateUrl: "./collaborator-invitations-tab.component.html",
  styleUrl: "./collaborator-invitations-tab.component.scss",
})
export class CollaboratorInvitationsTabComponent {
  private readonly collaboratorsService = inject(CollaboratorsService);

  private readonly page$ = new Subject<PaginatorState | undefined>();
  private readonly refreshInvitations$ = new Subject<void>();

  private router = inject(Router);
  isLoading = true;

  myInvitations$ = combineLatest([
    this.page$.pipe(startWith(undefined)),
    this.refreshInvitations$.pipe(startWith(null)),
  ]).pipe(
    switchMap(([page]) =>
      this.collaboratorsService
        .getUserInvitations(page)
        .pipe(finalize(() => (this.isLoading = false))),
    ),
  );

  handleAcceptInvitationClick(invitation: CollaboratorInvitation) {
    this.isLoading = true;
    this.collaboratorsService
      .acceptInvitation(invitation.token)
      .pipe(
        finalize(() => (this.isLoading = false)),
        tap(() => {
          if (invitation.role === CollaboratorRoleEnum.MARKETING) {
            this.router.navigate(
              ["/producer-area/event", invitation.event_id],
              { queryParams: { tab: "7" } },
            );
          } else if (
            invitation.role === CollaboratorRoleEnum.PDV_PORTARIA_COORDINATOR
          ) {
            this.router.navigate(
              ["/producer-area/event", invitation.event_id],
              { queryParams: { tab: "5" } },
            );
          } else if (invitation.role === CollaboratorRoleEnum.OBSERVER) {
            this.router.navigate([
              "/producer-area/event",
              invitation.event_id,
            ]);
          } else if (invitation.role !== CollaboratorRoleEnum.MANAGER) {
            this.router.navigate([
              "/collaborator-success",
              invitation.event_id,
            ]);
          }
        }),
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe();
  }

  handlePageChange(page: PaginatorState) {
    this.page$.next(page);
  }
}
